angular.module('cian.ui.button', [])
.config(["$interpolateProvider", function($interpolateProvider) {
  $interpolateProvider.startSymbol('{$');
  $interpolateProvider.endSymbol('$}');
}]);

angular.module('cian.ui.button')
.directive('button', function () {
  return {
      scope: {
        text:         '@',
        size:         '@',
        buttonStyle:  '@',
        action:       '@',
        arrow:        '@',
        onChange:     '&',
        onCrossClick: '&',
        classes:      '@',
        cross:        '@',
        isPopupOpen:  '='
      },
      require: '?ngModel',
      restrict: 'A',
      replace: true,
      template: ['<div class="s-button" ng-class="[\'s-button_size_\' + (size || \'s\'), buttonStyle ? \'s-button_\' + buttonStyle : \'\', behavior ? \'s-button_\' + behavior:\'\', action ? \'s-button_action\':\'\', arrow ? \'s-button_arrow\':\'\', isPopupOpen ? \'is-popup-open\':\'\', classes ? classes : \'\']">',
                  '<div class="s-button__text">{$ text $}</div>',
                  '</div>'].join(''),
      link: function(scope, elem, attrs, modelCtrl) {
        if (scope.$eval(attrs.cross)) {
          var crossElem = angular.element('<div class="s-button__icon c-icon c-icon_cross"></div>');
          crossElem.bind('click', function() {
            scope.onCrossClick();
          });
          elem.append(crossElem);
        }

        if (attrs.behavior === 'radio' && modelCtrl) {
          modelCtrl.$render = function() {
            elem.toggleClass('s-button_active', angular.equals(modelCtrl.$modelValue, attrs.value));
          };

          elem.bind('click', function() {
            scope.$apply(function() {
              modelCtrl.$setViewValue(attrs.value);
              modelCtrl.$render();
              if (typeof scope.onChange === 'function') scope.onChange({value: attrs.value});
            });
          });
        }

        if (attrs.behavior === 'checkbox' && modelCtrl) {
          modelCtrl.$render = function() {
            elem.toggleClass('s-button_active', !!modelCtrl.$modelValue);
          };

          elem.bind('click', function() {
            scope.$apply(function() {
              modelCtrl.$setViewValue(!modelCtrl.$modelValue);
              modelCtrl.$render();
              if (typeof scope.onChange === 'function') scope.onChange({value: modelCtrl.$modelValue});
            });
          });
        }
      }
    };
});



//////////////////
// WEBPACK FOOTER
// ../components/ui/src/button/button.js
// module id = 903
// module chunks = 0